import React, { createContext, useEffect, useReducer } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

import PageNotFound from '../../../404';
import HideServicesHeader from './components/Header';
import HideServicesTable from './components/Table';
import Loader from '../../../../components/Loaders/Loader';

import { listError, listSuccess, reducer } from './reducer';
import { servicesHideList } from '../../../../services/endpoints/services';
import { getErrorMessage } from '../../../../utils/helper';

export const Context = createContext({});
const HideServices = () => {
  const [state, dispatch] = useReducer(reducer, Context);
  const { isInitPage, initPageError, updateList } = state;

  const location = useLocation();
  const queryString = qs.parse(location.search.slice(1));

  const initPage = async () => {
    try {
      const requestPull = [await servicesHideList(queryString)];

      const [respList] = await Promise.all(requestPull);
      const payload = {
        ...respList.data,
      };
      dispatch(listSuccess(payload));
    } catch (error) {
      const data = getErrorMessage(error);
      const status = error.status ? error.status : 500;
      const statusText = error.statusText ? error.statusText : 'Unknown error';
      dispatch(listError(data, status, statusText));
    }
  };

  useEffect(() => {
    if (!isInitPage || updateList) {
      initPage();
    }
    document.title = 'Services hide';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateList]);

  if (!isInitPage) {
    return <Loader />;
  }

  if (isInitPage && initPageError) {
    return <PageNotFound errorDataMessage={initPageError?.data} errorStatus={initPageError?.status} errorStatusText={initPageError?.statusText} />;
  }

  return (
    <Context.Provider value={[state, dispatch]}>
      <HideServicesHeader />
      <HideServicesTable />
    </Context.Provider>
  );
};

export default HideServices;
